<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    width="900px"
    :title="'选择发运单'"
    :close-on-click-modal="false"
    :before-close="() => close()"
    destroy-on-close
    append-to-body
    v-el-dialog-drag
  >
    <el-alert type="warning" show-icon :closable="false">
      <span slot="title">
        检测到该客户下已有<b class="color">待订舱</b>状态的发运单,可以选择<b
          class="color"
          >追加</b
        >所有PO到选中的发运单当中或者<b class="color">新建</b>一张发运单
      </span>
      <div slot="default">
        <span><b class="color">追加：</b>将PO追加到选择的发运单</span>
        <br />
        <span><b class="color">新建：</b>创建新的发运单</span>
      </div>
    </el-alert>

    <ChooseShipment
      ref="chooseShipment"
      :custCode="custCode"
      :endCustCode="endCustCode"
      @radioChange="radioChange"
    />
    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        type="success"
        size="small"
        @click="addSave()"
        :disabled="!disabled"
      >
        {{ $l('INDEX.btn_new') || '新建' }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        :disabled="disabled"
        @click="confirm()"
      >
        {{ $l('INDEX.btn_append') || '追加' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import ChooseShipment from './index.vue'
export default {
  components: { ChooseShipment },
  props: {
    visible: { type: Boolean, default: false },
    custCode: { type: String, default: '' },
    endCustCode: { type: String, default: '' },
  },
  data() {
    return {
      disabled: true,
    }
  },
  methods: {
    confirm() {
      const data = this.$refs.chooseShipment.choiceData()
      if (!data) return
      this.close()
      this.$emit('confirm', data)
    },
    close() {
      this.disabled = true
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    addSave() {
      this.close()
      this.$emit('confirm', {})
    },
    radioChange(data) {
      if (data) {
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.color {
  color: #409eff;
}
</style>
